<template>
  <div class="container">
    <!-- <template> -->
    <div>
      <div class="row">
        <div class="col-md-3"></div>
        <div class="col-md-6 col-sm-12">
          <img
            class="pb-3 rounded-circle"
            :src="require('../../../assets/logo_cuadro.jpg')"
            width="100%"
          />
        </div>
        <div class="col-md-3"></div>
      </div>
    </div>

    <h1 class="text-center py-5 font display-1">
      <strong>{{ text }}</strong>
    </h1>
    <!-- </template> -->
  </div>
</template>

<script>
export default {
  props: ["text"],
  name: "401",
};
</script>

<style>
</style>